<template>
    <!-- <Backer /> -->
    <div :style="{'max-width': '1300px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">
        <div><h3>New Store Transfer</h3></div>
        <b-card  style="padding: 5px;">
            <div style="display: inline-block; margin: 5px; width: 200px;">
                <div>
                    Location
                </div>
                <b-form-select
                    size="sm"
                    v-on:change="set_location"
                    style="max-width: 250px;"
                >
                    <b-form-select-option
                        v-for="location, lidx in packet.locsubs1" 
                        :value="location.value" 
                        v-bind:key="location.value"
                    >
                        {{location.text}}
                    </b-form-select-option>
                </b-form-select>
            </div>

            <div style="display: inline-block; margin: 5px; width: 200px;">
                <div>
                User
                </div>
                <div style="padding: 5px; background: #f2f2f2;">
                    {{ userDetails.username }}
                </div>
            </div>

            <div style="display: inline-block; margin: 5px; width: 200px;">
                <div>
                Date
                </div>
                <div style="padding: 5px; background: #f2f2f2;">
                    {{ ts }}
                </div>
            </div>
        </b-card>

        <div v-if="invoice.location_id">
            <b-card-group style="margin-top: 10px;">
                <b-card header="Requesting Location">
                    <b-alert show variant="secondary">
                        <div>
                            LOCATION: {{ 
                                packet.locations.filter(
                                    function(d){return d.value == invoice.location_id}
                                )[0].text
                            }}
                        </div>
                        <div>
                            ADDRESS: {{ 
                                packet.locations.filter(
                                    function(d){return d.value == invoice.location_id}
                                )[0].address
                            }}
                        </div>
                        <div>
                            PHONE: {{ 
                                packet.locations.filter(
                                    function(d){return d.value == invoice.location_id}
                                )[0].phone
                            }}
                        </div>
                    </b-alert>
                </b-card>
            </b-card-group>

            <b-card header="Products" style="margin-top: 10px;">
                <b-alert show variant="warning" v-if="invoice.items.length == 0">No items added</b-alert>
                <div v-else style="padding: 0px;">
                    <table style="width: 100%; border-collapse: separate; border-spacing: 0px 5px;">
                        <thead>
                            <tr style="background: black; color: white;">
                                <td class="ipt_tdhr">#</td>
                                <td class="ipt_tdhr">PRD</td>
                                <td class="ipt_tdhr">PRICE</td>
                                <td class="ipt_tdhr">QTY</td>
                                <!-- <td class="ipt_tdhr">DISCNT</td> -->
                                <td class="ipt_tdhr">TYPE</td>
                                <td class="ipt_tdhr">DATE NEEDED</td>
                                <td class="ipt_tdhr">FULFILL FRM</td>
                                <td class="ipt_tdhr">ACTION</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item, idx in invoice.items" v-bind:key="idx">
                                <td class="ipt_tdr">{{ idx + 1}}</td>
                                <td class="ipt_tdr" style="max-width: 220px;">
                                    <b-card-text>{{ (item.product_name || item.product_sku) }}</b-card-text>
                                </td>
                                <td class="ipt_tdr">
                                    <b-card-text>${{item.wholesale_price}}</b-card-text>
                                </td>

                                <td class="ipt_tdr">
                                    <b-card-text>
                                        <b-input style="width: 50px; text-align: center;" v-model="item.quantity" size="sm"></b-input>
                                    </b-card-text>
                                </td>

                                <!-- <td class="ipt_tdr">
                                    <b-card-text>
                                        <b-input style="width: 50px; text-align: center;" v-model="item.discount_offered" size="sm"></b-input>
                                    </b-card-text>
                                </td> -->

                                <td class="ipt_tdr" style="max-width: 150px;">
                                    <b-form-select
                                        v-model="item.order_type"
                                        :options="order_types"
                                        size="sm"
                                        style="width: 140px;"
                                    ></b-form-select>

                                    <b-card-text v-if="item.order_type == 'customer_takes'">
                                        
                                        <b-form-select
                                            v-model="item.source_locsub"
                                            :options="packet.locsubs.filter(function(d){ return d.location_id == invoice.location_id } )"
                                            size="sm"
                                            style="width: 140px;"
                                            v-on:change="set_source_location(item)"
                                        ></b-form-select>
                                    </b-card-text>
                                </td>

                                <td class="ipt_tdr">
                                    <flat-pickr v-model="item.delivery_date" :config="flatpickrConfig" style="padding: 7px; font-size: 14px; text-align: center; border: 1px solid gray;"></flat-pickr>
                                </td>

                                <td class="ipt_tdr">
                                    <b-form-select 
                                        size="sm" 
                                        style="max-width: 200px; font-size: 9px;"
                                        v-model="item.locsub"
                                        :disabled="(item.product_id < 0 || !item.product_id)"
                                    >
                                        <b-form-select-option v-for="locsub,lidx in packet.locsubs2" :value="locsub.value" v-bind:key="lidx">
                                            {{ all_loc_inventory_dict[
                                                JSON.stringify(item.product_id)
                                                +
                                                item.product_sku
                                                +
                                                JSON.stringify(locsub.location_id)
                                                +
                                                JSON.stringify(locsub.sublocation_id)
                                            ]}} 

                                            - 

                                            {{ locsub.location }} | {{ locsub.sublocation }} 
                                        </b-form-select-option>
                                    </b-form-select>
                                </td>

                                <td class="ipt_tdr">
                                    <b-button variant="outline-danger" size="sm" @click="removeItem(idx)">REMOVE</b-button>
                                </td>
                                 
                            </tr>
                        </tbody>
                    </table>
                </div>                    
            </b-card>


            <b-card header="Add Custom" style="margin-top: 10px;">
                <b-button v-b-toggle.collapse-2 variant="primary" size="sm" style="margin: 10px; ">Add Custom</b-button>

                <b-collapse id="collapse-2" class="mt-2">
                    <b-card-body style="padding: 5px;">
                        <b-card-text style="display: inline-block;">
                            <div>SKU</div>
                            <b-input size="sm" style="width: 200px;" v-model="special_item.product_sku">
                            </b-input>
                        </b-card-text>

                        <b-card-text style="display: inline-block;">
                            <div>VENDOR</div>
                            <b-form-select :options="packet.vendors" v-model="special_item.vendor" style="width: 120px;" size="sm"></b-form-select>
                            </b-input>
                        </b-card-text>

                        <b-card-text style="display: inline-block;">
                            <div>QTY</div>
                            <b-input size="sm" style="width: 50px;" v-model="special_item.quantity">
                            </b-input>
                        </b-card-text>

                        <b-card-text style="display: inline-block;">
                            <div>PRICE</div>
                            <b-input size="sm" style="width: 60px;" v-model="special_item.selling_price">
                            </b-input>
                        </b-card-text>


                        <b-button size="sm" variant="success" @click="addProduct(special_item)">Add</b-button>

                    </b-card-body>
                </b-collapse>
            </b-card>



            <b-card header="Search Products" style="margin-top: 10px;">
                <b-button v-b-toggle.collapse-1 variant="primary" size="sm" style="margin: 10px; ">Add Items</b-button>

                <b-collapse id="collapse-1" class="mt-2">
                    
                    <b-card-body style="padding: 5px;">
                        <b-form @submit="search">
                            <b-card-text>
                                <b-form-input 
                                    style="max-width: 300px; display: inline-block; margin: 3px;" 
                                    v-model="searchitems.keyword"
                                    required
                                    size="sm"
                                ></b-form-input>

                                <b-button 
                                    variant="warning" 
                                    style="display: inline-block; vertical-align: top; margin: 3px;" 
                                    size="sm"
                                    type="submit">Search
                                </b-button>

                                <b-button 
                                    variant="success" 
                                    size="sm"
                                    style="display: inline-block; vertical-align: top; margin: 3px;" 
                                    @click="initItemScan">Scan
                                </b-button>

                            </b-card-text>
                        </b-form>

                        <b-overlay
                            :show="searchitems.search_being_loaded"
                            variant="white"
                            opacity="0.85"
                            blur="1rem"
                            rounded="sm"
                        >   
                            <div v-if="searchitems.result.length>   0">
                                <table hover small bordered style="width: 100%;" >
                                <thead>
                                    <tr style="background: slategray; color: white;">
                                        <td class="ipt_tdhr">SKU</td>
                                        <td class="ipt_tdhr">PRODUCT</td>
                                        <td class="ipt_tdhr">WHLSL PRICE</td>
                                        <td class="ipt_tdhr">QTY</td>
                                        <td class="ipt_tdhr">AVLBL</td>
                                        <td class="ipt_tdhr">ACTION</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sitem, sidx in searchitems.result" v-bind:key="sitem.product_sku">
                                        <td class="ipt_tdr">{{sitem.product_sku}}</td>
                                        <td class="ipt_tdr">{{sitem.product_name}}</td>
                                        
                                        <td class="ipt_tdr">${{sitem.wholesale_price}}</td>

                                        <td class="ipt_tdr">
                                            <b-card-text>
                                                <b-input size="sm" style="width: 50px;" v-model="sitem.quantity"></b-input>
                                            </b-card-text>
                                        </td>

                                        <td class="ipt_tdr" :style="{background: ((sitem.availability < 5) ? '#ffa64145' : 'rgb(233, 255, 214)')}">
                                            <b-card-text>
                                                {{sitem.availability}}
                                            </b-card-text>
                                        </td>

                                        <td>
                                            <b-button variant="success" size="sm" @click="addProduct(sitem)">Add</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                            <div v-else>
                                <b-alert variant="light" show>No Products To Show</b-alert>
                            </div>
                        </b-overlay>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card header="CHARGES" style="margin-top: 10px;">
                
                <b-card-group column>
                    <b-card>
                        <div style="display: inline-block; margin: 3px;">
                            Delivery ($)
                            <b-input size="sm" v-model="invoice.delivery_charges" style="width: 75px;"></b-input>
                        </div>

                        <!-- <div style="display: inline-block; margin: 3px;">
                            Setup
                            <b-input size="sm" v-model="invoice.setup_charges" style="width: 75px;"></b-input>
                        </div>

                        <div style="display: inline-block; margin: 3px;">
                            Warranty
                            <b-input size="sm" v-model="invoice.warranty_charges" style="width: 75px;"></b-input>
                        </div>
 -->
                    </b-card>
                    <b-card>
                        <div style="display: block; margin-top: 3px;">
                            <div style="display: inline-block; width: 100px;">Total Discnt: </div>
                            <div style="display: inline-block; background: #efefef; padding: 3px; width: 100px; text-align: center;">
                            {{ (getTotalDiscount()).toFixed(2) }}
                            </div>
                        </div>

                        <div style="display: block; margin-top: 3px;">
                            <div style="display: inline-block; width: 100px;">Order Totl: </div>
                            <div style="display: inline-block; background: #efefef; padding: 3px; width: 100px; text-align: center;">
                            {{ (getOrderTotal()).toFixed(2) }}
                            </div>
                        </div>

                        <div style="display: block; margin-top: 3px;">
                            <div style="display: inline-block; width: 100px;">Totl Charges: </div>
                            <div style="display: inline-block; background: #efefef; padding: 3px; width: 100px; text-align: center;">
                             {{ (getChargesTotal()).toFixed(2) }}
                            </div>
                        </div>

                        <div style="display: block; margin-top: 3px;">
                            <div style="display: inline-block; width: 100px;">Subtotal: </div>
                            <div style="display: inline-block; background: #efefef; padding: 3px; width: 100px; text-align: center;">
                             {{ (getSubTotal()).toFixed(2) }}
                            </div>
                        </div>

                        <!-- <div style="display: block; margin-top: 3px;">
                            <div style="display: inline-block; width: 100px;">Sales Tax: </div>
                            <div style="display: inline-block; background: #efefef; padding: 3px; width: 100px; text-align: center;">
                             {{ (getSalesTax()).toFixed(2) }}
                            </div>
                        </div> -->

                        <div style="display: block; margin-top: 3px;">
                            <div style="display: inline-block; width: 100px;">Grand Total: </div>
                            <div style="display: inline-block; background: lightgreen; padding: 3px; width: 100px; text-align: center;">
                             {{ (getGrandTotal()).toFixed(2) }}
                            </div>
                        </div>

                        <div style="display: block; margin-top: 3px;">
                            <div style="display: inline-block; width: 100px;">Balance: </div>
                            <div style="display: inline-block; background: lightyellow; padding: 3px; width: 100px; text-align: center;">
                             {{ (getTotalBalance()).toFixed(2) }}
                            </div>
                        </div>
                    </b-card>
                </b-card-group>
            </b-card>

            <b-card header="PAYMENT INFO" style="margin-top: 10px;">
                <div>
                    <b-card-group columns>
                        <b-card 
                            v-for="payment_method, pmidx in invoice.payment_methods"
                            no-body
                            style="max-width: 20rem;"
                            border-variant="secondary"
                            v-bind:key="payment_method.value"
                        >
                            <template v-slot:header>
                                {{payment_method.value}} 
                            </template>
                            <b-card-body>
                                <b-card-text>
                                    <b-form-select
                                        value-field="value"
                                        text-field="text"
                                        :options="payment_method_options"
                                        v-model="invoice.payment_methods[pmidx].value"
                                        size="sm"
                                    ></b-form-select>
                                </b-card-text>
                            </b-card-body>

                            <b-card-text>
                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'cash'">
                                    <b-list-group-item>
                                        <div>Amount</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount"></b-input></div>
                                    </b-list-group-item> 
                                </b-list-group>

                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == '90_day_credit_term'">
                                    <b-list-group-item>
                                        <div>Amount</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount"></b-input></div>
                                    </b-list-group-item> 
                                </b-list-group>


                                <!-- <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'cc'">
                                    <b-list-group-item>
                                        <div>Amount</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount"></b-input></div>
                                    </b-list-group-item> 
                                </b-list-group>

                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'finance'">
                                    <b-list-group-item>
                                        <div>Amount</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount"></b-input></div>
                                    </b-list-group-item>

                                    <b-list-group-item>
                                        <div>Company</div>
                                        <b-form-select
                                            value-field="value"
                                            text-field="text"
                                            :options="finance_companies"
                                            v-model="invoice.payment_methods[pmidx].finance_company"
                                            size="sm"
                                        ></b-form-select>
                                    </b-list-group-item>

                                    <b-list-group-item>
                                        <div>Lease #</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].lease_id"></b-input></div>
                                    </b-list-group-item>

                                    <b-list-group-item>
                                        <div>Misc Info</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].misc_info"></b-input></div>
                                    </b-list-group-item>
                                </b-list-group>


                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'store_credit'">

                                    <b-list-group-item>
                                        <div>Available Amount</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].available_amount" :disabled="true"
                                        ></b-input></div>
                                    </b-list-group-item>

                                    <b-list-group-item>
                                        <div>Amount</div>
                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount"
                                        ></b-input></div>
                                        <sub>Should be less than available amount</sub>
                                    </b-list-group-item>

                                    <b-list-group-item>
                                        <div>Invoice #</div>
                                        <div>
                                            <b-input size="sm" placeholder="Enter Invoice ID" v-model="invoice.payment_methods[pmidx].store_credit_invoice_id"></b-input>

                                            <b-button size="sm" style="margin-top: 10px;" variant="outline-primary" @click="apply_store_credit(pmidx)">APPLY</b-button>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group> -->
                            </b-card-text>

                            <b-card-text style="padding: 5px; text-align: center;">
                                <b-button size="sm" variant="outline-danger" style="">Remove</b-button>
                            </b-card-text>
                        </b-card>

                    </b-card-group>
                </div>

                <b-card-text>
                    <b-button size="sm" variant="dark" @click="addPaymentMethod">Add Payment Method</b-button>
                </b-card-text>
            </b-card>

            <b-card>
                <div v-if="!invoice.invoice_id">
                    <b-button variant="success" size="sm" @click="submitInvoice">Submit</b-button>
                </div>
                <div v-else>
                    <b-button variant="success" size="sm" @click="submitInvoice">Update</b-button>
                </div>
            </b-card>

            <b-modal id="modal-scanner" scrollable title="Scan Item" size="lg" hide-footer>
                <SimpleScanner @scanCompleted="fetchScannedItem" />
            </b-modal>
        </div>
    </div>
</template>

<script>
    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"
    import SimpleScanner from "@/components/importables/SimpleScanner"
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        name: "NewSale",
        props: ["viewdata"],
        components: {Backer, SimpleScanner, flatPickr},
        data: function() {
            let out = {
                ts: moment().format("MM-DD-YYYY hh:MM A"),
                global_vars: global_vars,
                userDetails: {properties: {}},
                packet: {},
                items: [],
                searchitems: {
                    search_being_loaded: false,
                    keyword: null,
                    limit: 500,
                    result: []
                },
                special_item: {
                    product_id: null,
                    product_sku: null,
                    product_name: null,
                    product_category:  null,
                    quantity: null,
                    selling_price: null,
                    discount_offered: 0.0,
                    vendor: null,
                },
                selected_location_id: null,
                invoice: {
                    invoice_id: null,
                    username: null, 
                    customer: {
                        fullname: null,
                        email: null,
                        phone: null,
                        phone_2: null,
                        address_line_1: null,
                        address_line_2: null,
                        floor: null,
                        apt: null,
                        city: null,
                        zipcode: null,
                        state: null
                    },
                    items: [],
                    delivery_charges: 0,
                    setup_charges: 0,
                    warranty_charges: 0,
                    payment_methods: [],
                    location_id: null,
                    sublocation_id: null,
                    sales_tax: 0.0,
                    delivery_date: null
                },
                location_id: null,
                sublocation_id: null,
                order_types: [
                    {"value": "mecca_inventory", "text": "Mecca Inventory"},
                    {"value": "special_order", "text": "Special Order"},
                    {"value": "ship_by_vendor", "text": "Ship By Vendor"},
                ],
                payment_method_options: [
                    // {value: "cc", text: "Credit Card"},
                    // {value: "cash", text: "Cash"},
                    // {value: "finance", text: "Finance"},
                    // {value: "store_credit", text: "Store Credit"},
                    {value: "90_day_credit_term", text: "90 Days Credit Term"}
                ],
                finance_companies: [
                    {value: "SNAP FINANCE", text: "SNAP FINANCE", phone_number: "1-877-557-3769"},
                    {value: "U-OWN LEASING", text: "U-OWN LEASING", phone_number: "1-877-353-8696"},
                    {value: "PREFERRED LEASE", text: "PREFERRED LEASE", phone_number: "1-770-575-5980"},
                    {value: "ACIMA CREDIT", text: "ACIMA CREDIT", phone_number: "1-801-297-1926"},
                    {value: "KORNERSTONE CREDIT", text: "KORNERSTONE CREDIT", phone_number: "1-888-521-5111"},
                    {value: "SYNCHRONY", text: "SYNCHRONY", phone_number: "1-800-677-0718"},
                    {value: "EASY PAY FINANCE", text: "EASY PAY FINANCE", phone_number: "1-866-337-2537"},
                    {value: "GREAT AMERICAN FINANCE", text: "GREAT AMERICAN FINANCE", phone_number: "1-866-944-2326"},
                ],
                all_loc_inventory_dict: {},
            }
            out.flatpickrConfig = { 
                dateFormat: "m-d-Y",
                disable: [
                    function(date) {
                        return (date < moment().add(5,'days'))
                    }
                ]
            }
            return out
        },
        methods: {
            apply_store_credit: function(pmidx){
                let store_credit_invoice_id = this.invoice.payment_methods[pmidx].store_credit_invoice_id;

                if (!store_credit_invoice_id){
                    this.$vex.dialog.alert(
                        {message: "Please specify valid invoice id"}
                    );
                    return
                }
                let path = "/api/sales/get_available_credit/"
                let data = {invoice_id: store_credit_invoice_id}
                let that = this;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        if (response.data.result.length > 0){
                            that.invoice.payment_methods[pmidx].available_amount = response.data.result[0].available_amount;


                            that.$bvToast.toast(
                                "Store credit retrieved.", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        else {
                            that.$bvToast.toast(
                                "No store credit found with the given invoice.",
                                {title: "Not found", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        
                    }
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred while applying store credit.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsyncP(path, data, this, s, f);

            },
            addProduct: function(item) {
                if (!item.quantity || isNaN(parseInt(item.quantity)) ){
                    this.$vex.dialog.alert({message: "Please specify valid count of item"});
                    return
                }

                if (!item.selling_price || isNaN(parseInt(item.selling_price)) ){
                    this.$vex.dialog.alert({message: "Please specify selling price of item"});
                    return
                }

                if (!item.product_sku){
                    this.$vex.dialog.alert({message: "Please specify valid sku of item."});
                    return
                }

                item.quantity = parseInt(item.quantity);
                let is_special = ((item.product_id == null) ? true :  false );

                if (is_special){
                    if (!item.vendor){
                        this.$vex.dialog.alert({message: "Please specify valid vendor for special item."});
                        return
                    }
                }

                let invitem = {
                    product_id: ((is_special) ? -1 : item.product_id),
                    product_name: item.product_name,
                    product_sku: item.product_sku,
                    vendor: item.vendor,
                    product_category: (item.category || null),
                    quantity: item.quantity,
                    selling_price: item.selling_price,
                    wholesale_price: item.wholesale_price,
                    discount_offered: 0.0,
                    children: item.elements,
                    is_special: is_special,
                    order_type: null,
                    pickup_date: null,
                    delivery_date: item.delivery_date,
                    location_id: this.location_id,
                    sublocation_id: this.sublocation_id,
                    source_location_id: null,
                    source_sublocation_id: null,
                    locsub: null
                }
                this.invoice.items.push(invitem);
            },
            set_location_id: function(location_id){
                this.invoice.location_id = location_id;
            },
            set_location: function(locsub) {
                let splt = locsub.split("|")
                this.invoice.location_id = +splt[0];
                this.invoice.sublocation_id = +splt[1];
            },
            set_source_location: function(item) {
                let locsub = item.source_locsub;
                let splt = locsub.split("|")
                item.source_location_id = +splt[0];
                item.source_sublocation_id = +splt[1];
                item.locsub = item.source_locsub;
            },
            search: function(e) {
                if (e) {
                    e.preventDefault();
                }
                let path = "/api/product/search_for_sale/"
                let data = {keyword: this.searchitems.keyword, limit: this.searchitems.limit};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.searchitems.result = response.data.result;
                    }
                    that.searchitems.search_being_loaded = false;
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error occurred while searching product.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.searchitems.search_being_loaded = false;
                }

                this.searchitems.search_being_loaded = false;
                Requestor.getSyncP(path, data, this, s, f);
            },
            initItemScan: function(e){
                if (e){
                    e.preventDefault();
                }
                this.$bvModal.show("modal-scanner");
            },
            fetchScannedItem: function(result){
                result = result.split("|");
                let data = {product_sku: result[1], product_id: parseInt(result[2])}
                let path = "/api/product/search_single_for_sale/"
                let that = this;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        if (response.data.result.length > 0){
                            that.searchitems.result = response.data.result;
                        }
                    }
                    that.$bvModal.hide("modal-scanner");
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error occurred while scanning product.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.$bvModal.hide("modal-scanner");
                }
                this.searchitems.search_being_loaded = false;
                Requestor.postSyncP(path, data, this, s, f);
            },
            submitInvoice: function(e) {
                if (e) {
                    e.preventDefault();
                }
                let invoice = this.invoice;
                invoice.warranty_charges = (+invoice.warranty_charges || 0.0);
                invoice.delivery_charges = (+invoice.delivery_charges || 0.0);
                invoice.setup_charges = (+invoice.setup_charges || 0.0);
                invoice.sales_tax = this.getSalesTax();

                //val # 1: confirm that user details are not empty
                let customer_error = this.validate_customer_info(invoice.customer);
                if (customer_error.length > 0){
                    this.$vex.dialog.alert({message: customer_error[0]})
                    return
                }

                //val # 2: confirm that products are not empty + product quanties are valid
                let products_error = this.validate_products(invoice.items);
                if (products_error.length > 0){
                    this.$vex.dialog.alert({message: products_error[0]})
                    return
                }

                //val # 3: confirm that the amounts specified in payment methods do add up the grand total.
                let payments_error = this.validate_payment_methods(invoice.payment_methods);
                if (payments_error.length > 0){
                    this.$vex.dialog.alert({message: payments_error[0]})
                    return
                }
                invoice.payment_methods = invoice.payment_methods.map(function(d){
                    d.amount = (+d.amount || 0.0); return d;
                });

                let that = this;
                let path = "/api/sales/record_sale/"
                if (invoice.invoice_id){
                    path = "/api/sales/update_sale/"
                }
                
                let data = invoice;
                data.username = this.userDetails.username;
                let loc = this.packet.locations.filter(function(d){
                    return d.value == data.location_id
                });
                if (loc.length > 0){
                    data.location_short = loc[0].short;
                }

                data.invoice_type = "TR";

                let s = function(response){
                    if (response.data.error){
                        // that.$bvToast.toast(
                        //     response.data.error, 
                        //     {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        // );
                        that.$vex.dialog.alert({
                            message: response.data.error
                        });
                    }
                    else {
                        //this means its a new sale
                        if (!that.invoice.invoice_id){
                            let invoice_id = response.data.result.invoice_id;
                            if (invoice_id){
                                that.$router.push({path: "/sales/viewsale/"+invoice_id+"/"});
                            }
                        }
                        else {
                            that.$bvToast.toast(
                                "Updated Invoice", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        
                    }
                    that.block_post_invoice=false;
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "An error occurred while registering sale. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.block_post_invoice=false;
                }
                this.block_post_invoice = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            getSubTotal: function(){
                let order_total = this.getOrderTotal();
                let total_charges = this.getChargesTotal();
                return (order_total + total_charges);
            },
            getItemTotal: function(idx){
                let item = this.invoice.items[idx];
                let sp = (+item.wholesale_price || 0.0);
                let qty = (+item.quantity || 1.0);
                let dsc = (+item.discount_offered || 0.0);
                return ( (sp*qty) - dsc ).toFixed(2);
            },
            getOrderTotal: function(){
                var k = 0.0;
                for (var i =0; i<this.invoice.items.length; i++){
                    console.log(this.invoice.items[i]);
                    let sp = (+this.invoice.items[i].wholesale_price || 0.0);
                    let qty = (+this.invoice.items[i].quantity || 1.0);
                    //let dsc = (+this.invoice.items[i].discount_offered || 0.0);
                    let dsc = 0.0;

                    k += ( (sp*qty) - dsc );
                }
                return k;

            },
            getChargesTotal: function(){
                let dlv = (+this.invoice.delivery_charges || 0.0);
                // let stp = (+this.invoice.setup_charges || 0.0);
                // let wtp = (+this.invoice.warranty_charges || 0.0);
                let stp = 0.0;
                let wtp = 0.0;
                return (dlv + stp + wtp);
            },
            getSalesTax: function(){
                // let total_charges = this.getChargesTotal();
                // let order_total = this.getOrderTotal();
                // let perc = 0.10;
                // return (order_total + total_charges) * perc;
                return 0.0
            },
            getTotalDiscount: function(){
                // var k = 0.0;
                // for (var i =0; i<this.invoice.items.length; i++){
                //     let dsc = (+this.invoice.items[i].discount_offered || 0.0);
                //     k += dsc;
                // }
                // return k;
                return 0.0
            },
            getGrandTotal: function(){
                let order_total = this.getOrderTotal();
                let total_charges = this.getChargesTotal();
                let sales_tax = this.getSalesTax();
                return (order_total + total_charges + sales_tax) * 1.0;
            },
            getTotalBalance: function(){
                let grand_total = this.getGrandTotal();
                let total_payments_applied = this.invoice.payment_methods.map(function(d){return (parseFloat(d.amount) || 0.0) }).reduce(   function(a, b){
                            return a + b;
                    }, 0); 
                return grand_total - total_payments_applied
            },
            addPaymentMethod: function(e){
                if (e){
                    e.preventDefault();
                }

                let new_payment_method = {
                    value: null,
                    amount: null,
                    properties: {},
                    available_amount: 0.0,
                    store_credit_invoice_id: null
                }
                this.invoice.payment_methods.push(new_payment_method);
            },
            removeItem: function(idx){
                this.invoice.items.splice(idx, 1);
            },
            removePaymentMethod: function(pmidx){
                this.invoice.payment_methods.splice(pmidx, 1);
            },
            validate_customer_info: function(customer_information){
                let errors = [];
                // if (!customer_information.fullname){
                //     errors.push("Please enter customer name.")
                // }
                // if (!customer_information.email){
                //     errors.push("Please enter customer email.")
                // }
                // if (!customer_information.phone){
                //     errors.push("Please enter customer phone.")
                // }
                // if (!customer_information.zipcode){
                //     errors.push("Please enter customer zipcode.")
                // }

                return errors;
            },
            validate_products: function(products){
                let errors = []
                if (products.length <=0){
                    errors.push("No products added to the Transfer.");
                }
                if (products.map(function(d){return (d.quantity || 0)}).indexOf(0) >= 0 ){
                    errors.push("Product quantity should be > 0.");
                }

                for (var i=0; i<products.length; i++){
                    // let pickup_date = products[i].pickup_date;
                    // let delivery_date = products[i].delivery_date;
                    let order_type = products[i].order_type;
                    let delivery_date = products[i].delivery_date;
                    let locsub = products[i].locsub;

                    if (!order_type){
                        errors.push("Please indicate order type for all items.");
                    }

                    if (order_type == "mecca_inventory"){
                        if (!locsub){
                            errors.push("Please select a fulfilling location for all mecca inventory orders.");
                        }
                    }

                    if (!delivery_date){
                        errors.push("Please indicate pickup or delivery date for for all items.");
                    }

                }
                return errors
            },
            validate_payment_methods: function(payment_methods){
                let errors = [];
                var s = 0;
                var gt = parseFloat(this.getGrandTotal().toFixed(2));
                for (var i=0; i<payment_methods.length; i++) {
                    s += (parseFloat(payment_methods[i].amount) || 0.0);

                    if (payment_methods[i].value == "finance"){
                        if (!(payment_methods[i].lease_id)){
                            errors.push("All finance related sales should include their lease/finance id.")
                        }
                        if (!(payment_methods[i].finance_company)){
                            errors.push("All finance related sales should include their lease/finance company name.")
                        }
                    }

                    if (payment_methods[i].value == "store_credit"){
                        if (payment_methods[i].amount > payment_methods[i].available_amount) {
                            errors.push("All the store credit amounts should be less or equal to available credit amount.")
                        }

                        if (isNaN(parseFloat(payment_methods[i].available_amount)) ||parseFloat(payment_methods[i].available_amount) == 0.0){
                            errors.push("No store credit can be applied with given information.")
                        } 
                    }
                }

                s = parseFloat(s.toFixed(2));
                gt = parseFloat(gt.toFixed(2));
                if (s < gt){
                    errors.push("Total payment amount should match the grand total.")
                }
                return errors
            },
            dateDisabled: function(ymd, date){
                return date <= moment()    
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/inventory/get_all_loc_inventory_dict/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response) {
                            if (response.data.result){
                                that.all_loc_inventory_dict = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error) {
                            that.$bvToast.toast(
                                "Error loading inventory.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
        },
        created: function() {
            let userDetails = localStorage.userDetails;
            let packet = localStorage.packet;
            if (userDetails) {
                this.userDetails = JSON.parse(userDetails);
                if (this.packet) {
                    this.packet = JSON.parse(packet);
                    if (['admin', 'officeuser'].indexOf(this.userDetails.userrole) < 0) {
                        let user_location = this.userDetails.properties.location_id;
                        this.packet.locations = this.packet.locations.filter(function(d){return d.value == user_location});
                        this.packet.locsubs1 = this.packet.locsubs.filter(function(d){return d.location_id == user_location});
                        this.packet.locsubs2 = this.packet.locsubs.filter(function(d){return d.location_id != user_location});
                    }
                    this.fetch_prereqs()
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 13px;
        background: inherit;
        border: 1px solid black;
    }
</style>


// WEBPACK FOOTER //
// src/components/StoreTransfers/NewTransfer.vue